import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import PaginationItem from './PaginationItem';

/*
 * A temporary replacement for Pagination in React-Bootstrap
 */
function Pagination(props) {
  const { className, currentPage, numPages, onPageItemClick } = props;

  // Determines the range of pages to render
  const maxRange = 5;
  const halfRange = Math.floor(maxRange / 2);
  let startPage;
  let endPage;
  if (currentPage <= halfRange) {
    startPage = 1;
    endPage = Math.min(maxRange, numPages);
  } else if (currentPage + halfRange >= numPages) {
    startPage = Math.max(numPages - maxRange + 1, 1);
    endPage = numPages;
  } else {
    startPage = currentPage - halfRange;
    endPage = currentPage + halfRange;
  }

  const hasLeftEllipsis = startPage > 2;
  const hasRightEllipsis = endPage < numPages - 1;
  const hasFirstPage = startPage > 1;
  const hasLastPage = endPage < numPages;

  // Prepare page items
  const items = [];
  for (let i = startPage; i <= endPage; ++i) {
    const item = (
      <PaginationItem
        key={i}
        isActive={i === currentPage}
        onClick={onPageItemClick}
        value={i}
      />
    );
    items.push(item);
  }

  const rootClassName = classNames('pagination', className);
  return (
    <ul className={rootClassName}>
      {/* Previous Page Button */}
      <PaginationItem
        isDisabled={currentPage <= 1}
        onClick={onPageItemClick}
        value={currentPage - 1}
      >
        &lsaquo;
      </PaginationItem>

      {/* First Page Button */}
      {hasFirstPage && <PaginationItem onClick={onPageItemClick} value={1} />}

      {/* Left Ellipsis Button */}
      {hasLeftEllipsis && <PaginationItem isDisabled>&hellip;</PaginationItem>}

      {/* Actual Page Items */}
      {items}

      {/* Right Ellipsis Button */}
      {hasRightEllipsis && <PaginationItem isDisabled>&hellip;</PaginationItem>}

      {/* Last Page Button */}
      {hasLastPage && (
        <PaginationItem onClick={onPageItemClick} value={numPages} />
      )}

      {/* Next Page Button */}
      <PaginationItem
        isDisabled={currentPage >= numPages}
        onClick={onPageItemClick}
        value={currentPage + 1}
      >
        &rsaquo;
      </PaginationItem>
    </ul>
  );
}

Pagination.defaultProps = {
  currentPage: 1,
  numPages: 1,
  onPageItemClick: null,
  className: '',
};

Pagination.propTypes = {
  currentPage: PropTypes.number,
  numPages: PropTypes.number,
  onPageItemClick: PropTypes.func,
  className: PropTypes.string,
};

export default Pagination;
